import { render, staticRenderFns } from "./DashboardApp.vue?vue&type=template&id=cb4e2b64&scoped=true&"
import script from "./DashboardApp.vue?vue&type=script&lang=js&"
export * from "./DashboardApp.vue?vue&type=script&lang=js&"
import style0 from "./DashboardApp.vue?vue&type=style&index=0&id=cb4e2b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4e2b64",
  null
  
)

export default component.exports